import React, { useState, useEffect } from 'react';
import CoachMessaging from '../components/CoachMessaging';
import { apiClient } from '../config/api';

interface MessagingPageProps {
  user: any; // This is the coach user
  coachMode?: boolean;
}

export const MessagingPage: React.FC<MessagingPageProps> = ({ user }) => {
  const [clients, setClients] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      setLoading(true);
      const response = await apiClient.getCoachClients();

      if (response.success && response.clients) {
        setClients(response.clients);
      } else {
        setError('Failed to load clients');
      }
    } catch (err) {
      console.error('Error fetching clients:', err);
      setError('Failed to load clients');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-8">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Client Messages
        </h1>
        <p className="text-gray-600">
          Communicate with your clients in real-time
        </p>
      </div>

      <CoachMessaging
        clients={clients}
        coachId={user?.id?.toString() || user?.user_id?.toString() || ''}
        coachName={user?.full_name || user?.email || 'Coach'}
      />
    </div>
  );
};
